import { ReactNode, useMemo } from 'react'
import styled from '@emotion/styled'
import Text from '../../../components/common/Text'
import { INPUT_ERROR, FONT_LIGHT_GRAY } from '../../../constant/colors'
import { numberWithCommas, useRouter } from '../../../utils/helper'
import Image from '../../../components/common/Image'
import IconCoin from '../../../assets/images/icons-coin-24-px.png'
import { mobile } from '../../../utils/responsive-helper'
import { UserSelectedBenefits } from '../../../services/enrollment/enrollment-types'
import HtmlWithStyled from '../../../components/HtmlWithStyled'

const Row = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: space-between;
`

const DescriptionLayout = styled(Row)`
  width: unset;
  align-items: flex-end;
  > *:not(:last-child) {
    margin-right: 8px;
  }
  color: ${FONT_LIGHT_GRAY};

  > * {
    font-family: IBMPlexSansThai-Medium;
  }

  ${mobile} {
    flex-flow: column;
  }
`

type BnefitsRowProps = {
  categoryName: string
  choiceName?: string
  choicesDescription?: string
  selectedCoinValue: number
}
const BenefitsRow = (props: BnefitsRowProps) => {
  const { categoryName, choicesDescription, selectedCoinValue: value } = props
  return (
    <div
      style={{
        minHeight: 75,
        borderStyle: 'solid',
        borderColor: '#f5f7fa',
        borderWidth: '0 1px 1px 1px',
        padding: 24,
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        <Text size={22} type={'Bold'}>
          {categoryName}
        </Text>
        <Text size={22} type={'Bold'} color={INPUT_ERROR} style={{ whiteSpace: 'nowrap' }}>
          <Image src={IconCoin} style={{ margin: 8 }} />
          {numberWithCommas(value ? -value : value)}
        </Text>
      </div>
      {choicesDescription && (
        <DescriptionLayout>
          <HtmlWithStyled html={choicesDescription} />
        </DescriptionLayout>
      )}
    </div>
  )
}

type BenefitsCategoryListProp = {
  userSelectedList: UserSelectedBenefits[]
  children: ReactNode
}
export const BenefitsCategoryList = (props: BenefitsCategoryListProp) => {
  const { children, userSelectedList } = props
  const BenefitsRows = useMemo(() => {
    return userSelectedList.map((userSelected: UserSelectedBenefits, index: number) => {
      const { categoryName, choiceName, choicesDescription, selectedCoinValue } = userSelected

      return (
        <BenefitsRow
          key={`${index}-${userSelected.id}-${userSelected.choicesId}`}
          categoryName={categoryName}
          choiceName={choiceName}
          selectedCoinValue={selectedCoinValue}
          choicesDescription={choicesDescription}
        />
      )
    })
  }, [userSelectedList])
  return (
    <>
      {BenefitsRows}

      {children && (
        <div
          style={{
            minHeight: 109,
            borderStyle: 'solid',
            borderColor: '#f5f7fa',
            borderWidth: '0 1px 1px 1px',
            padding: 32,
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
            {children}
          </div>
        </div>
      )}
    </>
  )
}

export default BenefitsCategoryList
